export default __webpack_public_path__ + "static/media/cart.2fa7df42.png";